import { Hair_API_PREFIX, buildHairApiUrl } from './apiConfig';
import { fetchWithTimeout } from './fetchWithTimeout';

export async function addCartItem({
  sessionId,
  scanId,
  token,
  userData,
  product,
  sourceSection,
  quantity = 1,
  priceInr,
  hairConcern,
}) {
  const url = buildHairApiUrl(`${Hair_API_PREFIX}/cart-items`);
  const body = {
    session_id: sessionId ?? null,
    scan_id: scanId ?? null,
    app_session_token: token ?? null,
    customer: {
      name: userData?.name ?? null,
      mobile_number: userData?.mobileNumber ?? userData?.phone ?? null,
      email: userData?.email ?? null,
      gender: userData?.gender ?? null,
      hair_type: userData?.hairType ?? userData?.hair_type ?? null,
      age: userData?.age ?? null,
    },
    product: {
      product_id: product?.product_id ?? product?.id ?? null,
      product_name: product?.product_name ?? product?.name ?? 'Product',
      description: product?.description ?? product?.why ?? product?.why_recommended ?? null,
      price_inr: priceInr ?? product?.price_inr ?? product?.sale_price ?? null,
      hair_concern: hairConcern ?? product?.hair_problem ?? product?.hair_concern ?? null,
    },
    quantity,
    source_section: sourceSection ?? null,
  };

  const response = await fetchWithTimeout(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    timeoutMs: 20000,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Failed to save cart item');
  }
  return data;
}
